module.exports = __webpack_public_path__ + "img/img_icon_40.6840eba8.png";